import { fixArabicFont } from "../../../helpers";

export function transformContents(contents: string) {
    contents = fixArabicFont(contents);
    return contents;
}
